module.exports = __webpack_public_path__ + "static/img/head.0e17800.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/head.jpg
// module id = tFkj
// module chunks = 4